module.exports = __webpack_public_path__ + "static/media/07b.f2ce7a36.png";